'use client';

import { useStudioDmThreads } from '@/api/queries/dm.queries';

/**
 * Unread-thread count for the studio Messages nav item (FRONT-312). Rendered
 * only inside the tester-gated item, so the query never fires for
 * non-testers (it is also gated in the hook itself).
 */
export function StudioMessagesBadge() {
  const { data } = useStudioDmThreads();
  const unread = (data?.threads ?? []).filter((t) => t.unread_count > 0).length;

  if (unread === 0) return null;

  return (
    <>
      <span className="ml-auto flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-red-primary px-1 text-[10.5px] font-bold text-white group-data-[collapsible=icon]:hidden">
        {unread > 99 ? '99+' : unread}
      </span>
      {/* Collapsed rail clips flow children (size-8 + overflow-hidden) —
          the icon mode gets an absolutely-positioned dot instead. */}
      <span className="absolute right-1 top-1 hidden size-2 rounded-full bg-red-primary group-data-[collapsible=icon]:block" />
    </>
  );
}
